import "../../FhBadge.css";
import { computed, openBlock, createElementBlock, normalizeClass, createBlock, createCommentVNode, renderSlot } from "vue";
import FhIcon from "../FhIcon/FhIcon.mjs";
import { VARIANTS_ENUMS, EMPHASIS_ENUMS, SIZES_ENUMS } from "./constants.mjs";
import { _ as _export_sfc } from "../../_plugin-vue_export-helper-1tPrXgE0.js";
const _sfc_main = {
  __name: "FhBadge",
  props: {
    variant: {
      type: String,
      default: VARIANTS_ENUMS.PRIMARY,
      validator: (value) => Object.values(VARIANTS_ENUMS).includes(value)
    },
    emphasis: {
      type: String,
      default: EMPHASIS_ENUMS.SUBTLE,
      validator: (value) => Object.values(EMPHASIS_ENUMS).includes(value)
    },
    size: {
      type: String,
      default: SIZES_ENUMS.SM,
      validator: (value) => Object.values(SIZES_ENUMS).includes(value)
    },
    icon: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    const props = __props;
    const computedBadgeClasses = computed(() => {
      return [
        "fh-badge",
        `fh-badge--${props.variant}-${props.emphasis}`,
        `fh-badge--${props.size}`
      ];
    });
    const computedIconSize = computed(() => props.size === "sm" ? "xs" : "sm");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: normalizeClass(computedBadgeClasses.value)
      }, [
        props.icon ? (openBlock(), createBlock(FhIcon, {
          key: 0,
          size: computedIconSize.value,
          icon: props.icon
        }, null, 8, ["size", "icon"])) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ], 2);
    };
  }
};
const FhBadge = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-f6494eb1"]]);
export {
  FhBadge as default
};
//# sourceMappingURL=FhBadge.mjs.map
